/**
 * Settings routes — lazy-loaded screens for all settings sections.
 *
 * Route tree (under /app/settings):
 *   /app/settings              → SettingsScreen (index)
 *   /app/settings/account      → AccountSection
 *   /app/settings/security     → ChangePasswordScreen
 *   /app/settings/notifications → NotificationsPreferencesScreen
 *   /app/settings/privacy      → PrivacySection
 *   /app/settings/rgpd         → RgpdExportScreen
 *   /app/settings/delete       → DeleteAccountScreen
 *   /app/settings/language     → LanguagePreferenceScreen
 *   /app/settings/theme        → ThemeToggleScreen
 *   /app/settings/legal        → LegalDocumentScreen
 *
 * Spec: lines 5398-5424.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const SettingsScreen = lazy(() =>
  import('./screens/SettingsScreen').then((m) => ({ default: m.SettingsScreen })),
);

const AccountSection = lazy(() =>
  import('./screens/AccountSection').then((m) => ({ default: m.AccountSection })),
);

const ChangePasswordScreen = lazy(() =>
  import('./screens/ChangePasswordScreen').then((m) => ({
    default: m.ChangePasswordScreen,
  })),
);

const NotificationsPreferencesScreen = lazy(() =>
  import('./screens/NotificationsPreferencesScreen').then((m) => ({
    default: m.NotificationsPreferencesScreen,
  })),
);

const PrivacySection = lazy(() =>
  import('./screens/PrivacySection').then((m) => ({ default: m.PrivacySection })),
);

const RgpdExportScreen = lazy(() =>
  import('./screens/RgpdExportScreen').then((m) => ({
    default: m.RgpdExportScreen,
  })),
);

const DeleteAccountScreen = lazy(() =>
  import('./screens/DeleteAccountScreen').then((m) => ({
    default: m.DeleteAccountScreen,
  })),
);

const LanguagePreferenceScreen = lazy(() =>
  import('./screens/LanguagePreferenceScreen').then((m) => ({
    default: m.LanguagePreferenceScreen,
  })),
);

const ThemeToggleScreen = lazy(() =>
  import('./screens/ThemeToggleScreen').then((m) => ({
    default: m.ThemeToggleScreen,
  })),
);

const LegalDocumentScreen = lazy(() =>
  import('../legal/screens/LegalDocumentScreen').then((m) => ({
    default: m.LegalDocumentScreen,
  })),
);

export const settingsRoutes: RouteObject[] = [
  {
    path: 'settings',
    children: [
      { index: true, element: <SettingsScreen /> },
      { path: 'account', element: <AccountSection /> },
      { path: 'security', element: <ChangePasswordScreen /> },
      { path: 'notifications', element: <NotificationsPreferencesScreen /> },
      { path: 'privacy', element: <PrivacySection /> },
      { path: 'rgpd', element: <RgpdExportScreen /> },
      { path: 'delete', element: <DeleteAccountScreen /> },
      { path: 'language', element: <LanguagePreferenceScreen /> },
      { path: 'theme', element: <ThemeToggleScreen /> },
      { path: 'legal/:doc', element: <LegalDocumentScreen /> },
    ],
  },
];
